/* @ngInject */
function checkOverflow() {
  return {
    restrict: 'A',
    link(scope, element, attrs) {
      scope.$watch(() => element[0].scrollWidth, () => {
        const el = element[0];
        if (el.offsetWidth < el.scrollWidth) {
          Object.assign(attrs, { tooltipEnable: 'true' });
        } else {
          Object.assign(attrs, { tooltipEnable: 'false' });
        }
      });
    },
  };
}

export default checkOverflow;



// WEBPACK FOOTER //
// ./client/components/check-overflow/check-overflow.directive.js